import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import * as Sentry from "@sentry/react";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
import ReactHabitat from "react-habitat";
import determineLfcEnv from "./helpers/determineLfcEnv";
import getDefaultProps from "./helpers/getDefaultProps";
import LfcContainer from "./components/Container/LfcContainer";

determineLfcEnv(process.env.NODE_ENV) === "prod" &&
  Sentry.init({
    dsn: "https://f17e61a14c39ecbd530d44ab620fa431@o4505590205579264.ingest.sentry.io/4506224358129664",
    integrations: [
      new Sentry.BrowserTracing(),
      new CaptureConsoleIntegration({
        levels: ["warn", "error"],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 20% of the transactions
  });

const defaultProps = getDefaultProps();

class AppClass extends ReactHabitat.Bootstrapper {
  constructor() {
    super();

    // Create a new container builder:
    const builder = new ReactHabitat.ContainerBuilder();

    // Register a component:
    builder
      .register(LfcContainer)
      .as("LfcContainer")
      .withDefaultProps({
        ...defaultProps,
      });

    // Finally, set the container:
    this.setContainer(builder.build());
  }
}

// Always export a 'new' instance so it immediately evokes:
const App = new AppClass();
export default App;
